import React from 'react';

import {
  containsCustomStyling,
  removeCustomStylingMarkers,
  splitTextByCustomStyling
} from 'src/viewLayer/helpers/customStyling';
import { CustomComponentProps } from './types';

// customStyledComponents is an array of wrapper components to contain the custom-styled strings in order the ocurrence
export default (
  {
    translationText,
    customStyledComponents
  }: {
    translationText: string,
    customStyledComponents: React.FC[]
  }): JSX.Element[] => {
  let indexCustomStyledComponent = 0;
  let CustomStyledComponent: React.FC<CustomComponentProps>;

  return splitTextByCustomStyling(translationText).map((text) => {
    if (containsCustomStyling(text)) {
      CustomStyledComponent = customStyledComponents[indexCustomStyledComponent];
      indexCustomStyledComponent += 1;

      return (
        <CustomStyledComponent key={ text.slice(0, 24) }>
          { removeCustomStylingMarkers(text) }
        </CustomStyledComponent>
      );
    }
    return <span key={ text.slice(0, 32) } className="basicText">{text}</span>;
  });
};
